<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="element-header">
          Time management
        </h6>
      </div>
      <div class="element-box">
        <div class="d-flex justify-content-between mb-5">
          <h5>
            Mitarbeiter - Jahresübersicht (HR Übersicht)
          </h5>
          <button class="btn btn-primary custom_search_button2 w-auto ms-2" @click="
                        router.push({ name: 'monthlyOverview' });">
            Monatsübersicht
          </button>
        </div>

        <Search
            :userDropdown="userDropdown"
            :filters="filters" :loading="isSearching"
            :yearsDropdown="yearsDropdown"
            @search="getAnnualOverviewHr"/>

        <div class="row align-items-center justify-content-between mt-3">
          <div class="col-auto">
            <PerPage
                :values="[10, 25, 50, 100]"
                @update:perPage="getAnnualOverviewHr"/>

            <ExcelExportButton
                style="margin-right: 15px;"
                :label="$t('general.excel_export')"
                :loading="isExcelLoaded"
                @click="getExcelExport"/>

            <ExcelExportButton
                :label="$t('general.excel_export_monthly_details')"
                :loading="isExcelDetailsLoaded"
                @click="getExcelExportDetails"/>
          </div>
        </div>

        <div class="table-responsive overflow-auto mt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Mitarbeiternr</th>
              <th class="text-end">Arbeitszeit</th>
              <th class="text-end">Soll</th>
              <th class="text-end">davon im Büro</th>
              <th class="text-end">Überstunden</th>
              <th class="text-end">Urlaub</th>
              <th class="text-end">Sonderurlaub</th>
              <th class="text-end">Krankheitstage</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(annualOverview) in annualOverviewList.data" :key="annualOverview.id">
              <td>{{ annualOverview?.firstName + ' ' + annualOverview?.lastName }}</td>
              <td class="text-end">{{ annualOverview?.workedHours }}</td>
              <td class="text-end">{{ annualOverview?.planedHours }}</td>
              <td class="text-end">{{ annualOverview?.recalculatedPlanedHours }}</td>
              <td class="text-end">{{ annualOverview?.overtimeHours }}</td>
              <td class="text-end">{{ annualOverview?.numberOfVacationDays }}</td>
              <td class="text-end">{{ annualOverview?.numberOfSpecialLeaveDays }}</td>
              <td class="text-end">{{ annualOverview?.numberOfSickDays }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="annualOverviewList?.pagination?.total_pages > 1"
            :totalPages="annualOverviewList?.pagination?.total_pages"
            :currentPage="annualOverviewList?.pagination?.current_page"
            :totalItems="annualOverviewList?.pagination?.total_items"
            :perPage="annualOverviewList?.pagination?.items_per_page"
            @pagechanged="getAnnualOverviewHr"/>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import {timeManagementService} from '@/api/TImeManagement';

import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
import router from '@/router';
import {getUsersForHrOverviewDropdown, getYears} from '@/shared/dropdowns';
import {downloadFile} from '@/shared/functions';
import Search from '@/views/App/TimeManagement/TMAnnualOverview/Search.vue';
import {onMounted, ref} from 'vue';
import ExcelExportButton from '@/components/ExcelExportButton.vue';

const yearsDropdown = ref([]);
const userDropdown = ref([]);
const isLoaded = ref(false);
const annualOverviewList = ref([]);
const isExcelLoaded = ref(false);
const isExcelDetailsLoaded = ref(false);
const filters = ref({
  userId: '',
  year: yearsDropdown.value.at(-1)?.value || new Date().getFullYear(),

});

const isSearching = ref(false);

async function getAnnualOverviewHr(page = 1, perPage, passedFilters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }

  try {
    const perPageRes = annualOverviewList.value?.pagination?.items_per_page;
    const {data} = await timeManagementService.getAnnualOverviewHr({
          page: page,
          limit: perPage ?? perPageRes,
          ...(passedFilters ? passedFilters : filters.value),
        },
    );

    annualOverviewList.value = data.data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function getExcelExport() {
  await downloadFile(
      '/time-management/annual-overview-excel-export-hr',
      undefined, {...filters.value}, false, 'GET', isExcelLoaded)
}

async function getExcelExportDetails() {
  await downloadFile(
      '/time-management/annual-details-overview-excel-export-hr',
      undefined, {...filters.value}, false, 'GET', isExcelDetailsLoaded)
}

onMounted(async () => {
  await Promise.all([
    getYears(yearsDropdown),
    getAnnualOverviewHr(),
    getUsersForHrOverviewDropdown(userDropdown),
  ]);

  isLoaded.value = true;
});

</script>

<style scoped>
.nav.sm {
  width: max-content;
}
</style>